import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
var Stomp = require('@stomp/stompjs');
var SockJS = require('sockjs-client');

export default new Vuex.Store({
  state: {
    user1: 'Kunde',
    user2: 'Agent',
    token: '',
    dialog: '',
    dialogState: '',
    dialogs: '',
    businessCasesUngrouped: '',
    businessCasesOfDialog: '',
    cui: 0,
    socket: null,
    stompClient: null,
    error: '',
  },
  getters: {
    users: state => state.users
  },
  mutations: {
    updateUser1 (state, user) {
      state.user1 = user;
    },
    updateUser2 (state, user) {
      state.user2 = user;
    },
    updateToken (state, token) {
      state.token = token;
    },
    updateDialogState (state, dialogState) {
      state.dialogState = dialogState;
    },
    updateDialogs (state, dialogs) {
      state.dialogs = dialogs;
    },
    updateDialog (state, dialog) {
      state.dialog = dialog;
    },
    updateBusinessCasesUngrouped (state, businessCasesUngrouped) {
      state.businessCasesUngrouped = businessCasesUngrouped;
    },
    updateBusinessCasesOfDialog (state, businessCasesOfDialog) {
      state.businessCasesOfDialog = businessCasesOfDialog;
    },
    updateError (state, error) {
      state.error = error;
    }
  },
  actions: {
    async getDialogs ({ commit, state } ) {
      state.error = '';
      commit('updateDialogs', '');

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dialogues')
           .then(response => {
          commit('updateDialogs', response.data);
          resolve(response.data);
        }, error => {
          state.error = error;
          reject();
        })

      })
    },

    async getDialog ({ commit, state } ) { // TODO
      state.error = '';

      return new Promise((resolve, reject) => {
        if( state.dialog ) {
          Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId)
             .then(response => {
            commit('updateDialog', response.data);

            resolve(response.data);

            if( document.getElementById('siv') )
              document.getElementById('siv').scrollIntoView();
          }, error => {
            state.error = error;
            reject();
          })

        }
      })
    },
    async getDialogByID ({ commit, state }, payload ) { // TODO
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + payload.dialogId)
           .then(response => {
          commit('updateDialog', response.data);
          commit('updateUser1', response.data.participants[0].personName)
          commit('updateUser2', response.data.participants[1].personName)

          resolve(response.data);

          if( document.getElementById('siv') )
            document.getElementById('siv').scrollIntoView();
        }, error => {
          commit('updateError', error);
          reject();
        })
      })
    },
    async getDialogState ({ commit, state } ) {
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId + '/state')
           .then(response => {
          commit('updateDialogState', response.data);
          resolve(response.data);
        }, error => {
          commit('updateError', error);
          reject();
        })
      })
    },
    async getDialogStateByID ({ commit, state }, payload ) {
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + payload.dialogId + '/state')
           .then(response => {
          commit('updateDialogState', response.data);
          resolve(response.data);
        }, error => {
          commit('updateError', error);
          reject();
        })
      })
    },
    async addUtterance ({ dispatch, state }, payload ) { // TODO
      state.error = '';
      return new Promise((resolve, reject) => {
        if( state.dialog ) {
          Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId + '/utterances', {
              'personName': 'Agent',
              'text': payload.text })
             .then(response => {
            dispatch('getDialog');
            dispatch('getDialogState');
            dispatch('getBusinessCasesOfDialog', { 'dialogId': state.dialog.dialogueId})
            resolve(response.data);
          }, error => {
            state.error = error;
            reject();
          })
        }
      })
    },
    async addClientUtterance ({ dispatch, state } ) { // TODO
      state.error = '';
      var cu = [
        'Hallo, mein Name ist Max Müller. Ich habe meine Kreditkarte verloren.',
        'Das ist 31.10.1984',
        'Genau weiss ich das nicht. Ich hab sie gestern Vormittag das letzte Mal benutzt.',
        'In Linz am Bankomat.',
        'Ja, das muss wohl so gewesen sein.',
        'Prima, dankeschön.',
        'Ja, können Sie auch gleich veranlassen, dass ich eine neue Karte bekomme?'
      ];

      return new Promise((resolve, reject) => {
        if( state.dialog ) {
          Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId + '/utterances', {
              'personName': 'Kunde',
              'text': cu[state.cui] })
             .then(response => {
            state.cui = state.cui + 1;
            dispatch('getDialog');
            dispatch('getDialogState');
            dispatch('getBusinessCasesOfDialog', { 'dialogId': state.dialog.dialogueId});
            resolve(response.data);
          }, error => {
            state.error = error;
            reject();
          })
        }
      })
    },
    async saveSlot ({ dispatch, state }, payload ) { // TODO
      state.error = '';
      return new Promise((resolve, reject) => {
        if( state.dialog ) {
          Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + state.dialog.dialogueId + '/state/slots', {
              'slotId': payload.id,
              'value': payload.value })
             .then(response => {
            dispatch('getDialogState');
            resolve(response.data);
          }, error => {
            state.error = error;
            reject();
          })
        }
      })
    },
    async getBusinessCasesUngrouped ({ commit, state } ) {
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/businesscases/ungrouped' )
           .then(response => {
          commit('updateBusinessCasesUngrouped', response.data);
          resolve(response.data);
        }, error => {
          commit('updateError', error);
          reject();
        })
      })
    },
    async getBusinessCasesOfDialog ({ commit, state }, payload) {
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + payload.dialogId  + '/businesscases' )
           .then(response => {
          commit('updateBusinessCasesOfDialog', response.data);
          resolve(response.data);
        }, error => {
          commit('updateError', error);
          reject();
        })
      })
    },
    async setBusinessCaseStatusInDialogue ({ commit, state }, payload) {
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/dm/dialogues/' + payload.dialogId  + '/businesscases' , {
            'businessCaseId': payload.businessCaseId,
            'status': payload.status })
           .then(response => {
             console.log(response.data);
          commit('updateBusinessCasesOfDialog', response.data);
          resolve(response.data);
        }, error => {
          commit('updateError', error);
          reject();
        })
      })
    },

    async authenticate ({ commit, dispatch, state } ) {
      return new Promise((resolve, reject) => {

        Vue.http.post(process.env.VUE_APP_BACKEND_API_URL + '/authenticate', {
          "password": "admin",
          "rememberMe": true,
          "username": "admin"
        })
           .then(response => {

          commit('updateToken', response.data.id_token);

          Vue.http.interceptors.push(function(request) {
            request.headers.set('X-CSRF-TOKEN', 'TOKEN');
            request.headers.set('Authorization', 'Bearer ' +        response.data.id_token);
          });

          dispatch('getDialogs');
          dispatch('getBusinessCasesUngrouped');

          state.socket = new SockJS(process.env.VUE_APP_BACKEND_WEBSOCKET_URL + "/tracker?access_token=" + state.token);
            state.stompClient = Stomp.Stomp.over(state.socket);
            state.stompClient.connect(
              {},
              frame => {
                console.log(frame);
                state.stompClient.subscribe("/updates/dialogues", tick => {
                  console.log(tick);
                  if( state.dialog && tick.body && tick.body.dialogueId == state.dialog.dialogId ) {
                    console.log("MY Dialog has changed");
                    dispatch('getDialog');
                    dispatch('getDialogState');
                    dispatch('getBusinessCasesOfDialog', { 'dialogId': state.dialog.dialogueId});
                  }
                });
              },
              error => {
                console.log(error);
              }
            );

          resolve(response.data);
        }, error => {
          state.error = error;
          reject();
        })
      })
    },
  },
  modules: {
  }
})
